export const locale = {
    lang: 'de',
    data: {
      'RESULTADOS': {
        'TITULO': 'BERICHTERSTATTUNG',
        'DESCRIP': 'Wählen Sie eine Option',
        'CARGANDO': 'Umfrageergebnisse des Unternehmens werden geladen',
        'COMINGSOON': 'COVID Umfrageergebnisse kommen bald...',
        'VALIDANDO': {
          'BOTON': 'Im Validierungsprozess',
          'MENSAJE': 'Die Ergebnisse dieses Produkts sind in Bearbeitung, sie werden Ihnen bald zur Verfügung stehen',
        },
        'TABLAPRODUCTOS':{
          'COL1':'Jahr',
          'COL2':'Zugang',
          'BOT':'Zugriff',
        },

        'SECCIONES': {
          'TITULO_VER':'Version',
          'NOSECCIONES': 'Es sind keine Abschnitte verfügbar',

          'CERTIFICAR': {
            'TITULO': 'ZERTIFIZIEREN',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Eingabe'
          },
          'MEDIR': {
            'TITULO': 'MESSUNG',
            'INFO': 'Wählen Sie das Jahr aus, das Sie abfragen möchten',
            'BOTON': 'Eingabe'
          },
          'PULSE': {
            'TITULO': 'PULSKONTROLLE',
            'INFO': 'Wählen Sie das Jahr aus, das Sie abfragen möchten',
            'BOTON': 'Eingabe'
          },
          'MEDIR_AMCO': {
            'TITULO': 'ICI',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Eingabe'
          },
          'CertiAdicio': {
            'TITULO': 'ZUSÄTZLICHE ZERTIFIZIERUNGEN',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Eingabe'
          },
          'Amco': {
            'TITULO': 'AMCO',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Eingabe'
          },
          'TrabDign': {
            'TITULO': 'WÜRDIGE ARBEIT',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Eingabe'
          },
          'PrimEmp': {
            'TITULO': 'ERSTER JOB',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Eingabe'
          },
          'GOFLOW': {
            'TITULO': 'GoFlow-Ergebnisse',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Eingabe'
          },
        },

        'TABPRIN':{
          'TABPRO':'Zertifizierungsprozesse',
          'TAB4ALL': 'FORALL-Ergebnisse',
          'TAB4ALL2': 'Prozess-Ergebnisse',
          'TITURES': 'FORALL-Ergebnisse',
          'TABCER': 'Messprozesse',
          'TABPULSE': 'Pulskontrollprozesse',
          'TABICI': 'ICI-Ergebnisse',
          'TABAMCO': 'AMCO-Prozesse',
          'TABTRABDIG': 'Menschenwürdige Arbeitsprozesse',
          'TABPRIEMP': 'Erstbeschäftigungsprozesse',

        },
        'TABPRIN5':{
          'TABPRO':'Globaler Prozess der Version 3.1',
          'TAB4ALL':'Resultados FORALL',
          'TAB4ALL2':'Proceso de FORALL',
          'TITURES':'Resultados FORALL',
          'TABCER':'Lider versión 3.2 Lider Prozess',
          'TABPULSE':'Covid versión 3.3 Prozess',
        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL vererbte Ergebnisse',
         'BOTON': 'Start',
         'SIN_4ALL_HEREDADAS': "Sie rechnen nicht mit geerbten FORALL-Ergebnissen",
         'TITULOCERTIFICAR': "Zertifizieren",
         'APLICACIONANIO':'Antragsjahr: 2019',
        },
        '4ALL':{
            'CARGANDO':'Laden der 4ALL-Ergebnisse',
             'TITULO4ALL':'PRAXISERGEBNISSE',
             'TABPRACTICAS':{
              'TITULOTAB': 'Praktiken 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC': 'Globales Ergebnis der Praktiken FORALL',
              'TEXTO1':'Prozentsatz von ',
              'TEXTO2': 'Kenntnis von FORALL-Praktiken',
              'TEXTO3': 'in Ihrer Organisation',
              'TEXTO4': 'Niveau von',
              'TEXTO5': 'Zufriedenheit der Mitarbeiter, die sie kennen',
              'TEXTO6': 'FORALL-Praktiken',
            },
            'TITULOPRAC4All':{
              'TITULOTAB': 'Demographie',
              'SUBTITULO4ALL': 'Ergebnisse nach FORALL-Praxen',
              'TITULOCONO': 'WISSEN',
              'TEXTO1': 'Wissensanteil der FORALL-Praktiken in Ihrer Organisation',
              'TITULOSATIS': 'ZUFRIEDENHEIT',
              'TEXTO2': 'Zufriedenheitsgrad der Mitarbeiter, die die FORALL-Praxis kennen',
            }
          },

        'DEMOGRAFICOS':{
          'Cargo homologado': 'Zugelassene Position',
          'Años de Trabajo': 'Antique',
            'Condición de trabajo': 'Arbeitsbedingung',
            'Tipo de trabajo': 'Ausgleichsregelung',
            'Género': 'Geschlecht',
            'Educación': 'Akademischer Abschluss',
            'PORCONOTXT1': 'Prozentsatz von',
            'PORCONOTXT2': 'Kenntnisse über FORALL-Praktiken',
            'PORCONOTXT3': 'nach demographischem Schnitt',
            'PORSATITXT1': 'Niveau von',
            'PORSATITXT2': 'Zufriedenheit der Mitarbeiter, die die FORALL-Praktiken kennen',
            'PORSATITXT3': 'nach demographischem Zuschnitt',
         },
         'MODL_N_RESU':'Derzeit gibt es keine Ergebnisse',
         'MODL_N_RESU_4ALL':'Die angeforderten Ergebnisse können nicht angezeigt werden',
         },
         "ETIQ_MODAL_RESULT":{
           "TITLE_MODA":'Kein Ergebnis platformKey gefunden',
        "ETQ_PROD": "Produkt: ",
        "ETQ_BROK": "Broker: ",
        "ETQ_COUN": "Land: ",
        "ETQ_LANG": "Sprache: ",
        "ETQ_CERTY": "Zertifikat: ",
        "true": "Aktiviert",
        "false": "Deaktiviert",
        "COUNTR_NO_SELEC":"*Nicht ausgewählt*",
         }
      },
      'RESULTADOS_5':{
        'TITULO': 'Ergebnisse 5.0',
        'SECCIONES': {
          'NOSECCIONES': 'Nicht verfügbar',
          '31': {
            'TITULO': 'Globale Version 3.1',
            'INFO': 'Wählen Sie das Jahr aus, das Sie einsehen möchten',
            'BOTON': 'Go'
          },
          '32': {
            'TITULO': 'Leader Version 3.2',
            'INFO': 'Wählen Sie das Jahr, das Sie konsultieren möchten',
            'BOTON': 'Go'
          },
          '33': {
            'TITULO': 'Covid Version 3.3',
            'INFO': 'Wählen Sie das Jahr, das Sie konsultieren möchten',
            'BOTON': 'Go'
          }
        },
      },
      'CONFING_RESUL':{
      'TITULO_MODAL':'Konfiguration der BenchMarks-Ergebnisse',
      'TAB_DEMO_EXCEL':'Excel-Demografien',
      'SUB_TIT_TAB_DEMO_EXCEL':'Wählen Sie Demografien',
      'TAB_DEMO_ENCU':'Demografische Umfrage',
      'SUB_TIT_TAB_DEMO_ENCU':'Demografien auswählen:',
      'TAB_BENCHMA':'BenchMark',
      'SUB_TIT_TAB_BENCHMA':'',
      'TITULO_MAT_EXPAN_TAMANO':'Startseite',
      'TITULO_MAT_EXPAN_SECTOR':'Sektionale',
      'TITULO_MAT_EXPAN_REGIONAL':'Bereiche',
      'OKSELECT': 'Ausgewählt',
      'NOTSELECT':'Nicht ausgewählt',
      'TAB_NIV_GEOG':'Geografische Ebenen',
      'SUB_TIT_TAB_NIV_GEOG':'Geografische Ebenen auswählen:',
      'TAB_NIV_ESTRUC':'Strukturelle Ebenen',
      'SUB_TIT_TAB_NIV_ESTRUC':'Auswählen der Strukturebenen:',
      'BTN_ACEPTAR':'Übernehmen',
      'MODAL_CARGA_DEMO_EXC':'Demografische Daten laden',
      'MODAL_CARGA_DEMO_ENC':'Laden von Umfrage-Demografien',
      'MODAL_CARGA_BENCH':'Laden von Benchmarks',
      'MODAL_CARGA_NIV_GEO':'Laden von geografischen Ebenen',
      'MODAL_CARGA_NIV_ESTR':'Laden von Strukturebenen',
      'TAB_BENCH_MARK':'Benchmark',
      'MODAL_CARGA_BENCH_MARK':'Benchmarks laden',
      'SUB_TIT_TAB_BENCH_MARK':'Benchmarks auswählen:',
      'SUCCES_GUAR_SELEC':'Die Änderungen wurden korrekt gespeichert',
      'CONFI_GUAR_SELE':'Sind Sie sicher, dass Sie die vorgenommenen Änderungen speichern wollen?',
      'RES_SI':'Ja',
      'RES_NO':'Nein',
      'MAT_TOOL_BTN_CONFI_RESULT':'Konfiguration der Ergebnisse',
      'MODAL_GUA_INFOR':'Speichern von Informationen',
      'SUB_TIT_TAB_HIERARCHI':'HierarchicalPaths selection:',
      'MODAL_CARGA_HIERARCHI':'Loading HierarchicalPaths',
      'SIN__HIERARCHI_MOSTRAR':'Es gibt derzeit keine Ergebnisse in hierarchicalPaths',
      'EXTERNAL_PORTAL':'Kopieren Sie die Url der externen 4all',
      'INTRU_TEX_BENCHMARK':'*BenchMarks verschieben',
      'BENCHMARCK_SELEC':'Ausgewählte BenchMark in der Reihenfolge der Präsentation:',
      'BTN_SAV_BENCH':'BenchMarke speichern',
      'TEX_SEARC_BENCH_TOP':'Top-BenchMark für die Suche eingeben',
      'TEX_SEARC_BENCH_SECT':'Sektor-BenchMark für die Suche eingeben',
      'TEX_SEARC_BENCH_RANG':'BenchMark-Bereich für die Suche eingeben',
      'INFO_MAS_BENCH_ESPA':'gruppierte BenchMarks',
      'BTN_ADD_BENCH_SUGE':'Vorgeschlagene hinzufügen',
      'MOD_WARN_MAX_PERMIT':'Es kann nicht hinzugefügt werden, da es die Anzahl der zulässigen Leerzeichen überschreitet',
      'MOD_WARN_UN_CATE':'Zurzeit existiert bereits ein Benchmarks der ausgewählten Kategorie',
      'MOD_WARN_NO_APLIC':'Es ist nicht möglich, sie hinzuzufügen, da die Option, die BenchMarks nicht auszuwählen, aktiviert ist.',
      'INSTRU_DRAP&DROP_1':'Drag&Drop BenchMark hier',
      'LABE_CIRC_PROGRE':'BenchMarks',
      'LABE_INSTRU_SELECT_BENCH':'¿Möchten Sie BenchMarks auswählen?',
    },
    'CONFING_RESUL_GOFLOW':{
    'TITULO_MODAL':'Informationen zu den GoFlow-Ergebnissen',
      },
      'CONFING_RESUL_EMP':{
      'TITULO_MODAL':'Raw Data Emprising',
      'INT_TEX':'Anweisung: Bitte laden Sie die zu importierende Rohdaten-Datei hoch',
      'TOOLT_CHA_INF':'Ich habe die Datei ausgewählt',
      'UPLO_INF':'Importiere Zeilendaten',
      'SUCC_UPLO_INF':'Erfolgreich importiert',
      }
    }
};
